/**
 * Read a download name from a Content-Disposition header.
 *
 * Servers that follow RFC 6266 send both an ASCII `filename=` and a
 * UTF-8 `filename*`. The star parameter is the real name. `filename=` is
 * only a fallback for clients that do not understand `filename*`, and it
 * replaces characters such as é with underscores.
 *
 * An older header that put a percent-encoded name in `filename=` alone
 * still decodes.
 */
export function filenameFromContentDisposition(
  header: string | null | undefined,
  fallback = ''
): string {
  const value = header || '';
  const star = /filename\*\s*=\s*(?:UTF-8''|utf-8'')([^;\r\n]+)/i.exec(value);
  if (star && star[1]) {
    const decoded = decodeDispositionValue(star[1]);
    if (decoded) return decoded;
  }

  const quoted = /filename\s*=\s*"([^"]*)"/i.exec(value);
  if (quoted) {
    const decoded = decodeDispositionValue(quoted[1]);
    if (decoded) return decoded;
  }

  const bare = /filename\s*=\s*([^;\r\n]+)/i.exec(value);
  if (bare && bare[1]) {
    const decoded = decodeDispositionValue(bare[1]);
    if (decoded) return decoded;
  }

  return fallback;
}

function decodeDispositionValue(raw: string): string {
  const trimmed = raw.trim().replace(/^["']|["']$/g, '');
  if (!trimmed) return '';
  try {
    return decodeURIComponent(trimmed);
  } catch {
    return trimmed;
  }
}
